import React from 'react';
import { useIntl } from 'react-intl';
import { CollapsableBlock } from 'components/collapsable-block';
import { Text } from './styles';

interface CancellationInformationProps {
  cancellationRule: string;
  // RES-999: routed booking-details page embeds this inside its own card (see receipt-summary.tsx
  // / pages/booking-details/booking-details.tsx) and wants this section's heading — and the
  // spacing/divider around it — to match the card's other small grey labels rather than
  // CollapsableBlock's normal bold heading + top border. Defaults to false so every other caller
  // is unaffected.
  compact?: boolean;
  /*
   * RES-1367: the booking-details card's variant -- the bold heading of the default, without the
   * top border or the 28px lead-in that belong to a block leading a plain receipt page. Matches the
   * "Additional information" and "Amenities" blocks it now sits under in that card, so the three
   * read as one stack of sections rather than three different kinds of heading.
   */
  section?: boolean;
}

export const CancellationInformation = ({
  cancellationRule,
  compact = false,
  section = false,
}: CancellationInformationProps): JSX.Element => {
  const intl = useIntl();

  return (
    <CollapsableBlock title={intl.formatMessage({ id: 'cancellation_policy' })} compact={compact} section={section}>
      <Text>{cancellationRule}</Text>
    </CollapsableBlock>
  );
};
